import { z } from 'zod';
import { FlowProducedType } from '../../flowRun/producedType.js';
/**
 * Consumers of a type that is always required build a plain object schema. Consumers that may be
 * left unset (`FlowConsumerOfPatientSchema` and friends) default to an empty `sourceBlockName`
 * rather than being absent, so downstream code can read the field unconditionally.
 */
export const FlowConsumerOfExternalDocumentPacketSchema = z
    .object({
    // Don't require consumesType in the input payload, we hardcode it
    sourceBlockName: z.string(),
})
    .transform(({ sourceBlockName }) => ({
    sourceBlockName,
    consumesType: FlowProducedType.ExternalDocumentPacket,
}));
export function FlowConsumerOfPatientSchema(props) {
    const { isRequired } = props;
    return z
        .object({
        // Don't require consumesType in the input payload, we hardcode it
        sourceBlockName: z.string().min(isRequired ? 1 : 0, {
            message: 'Source block name is required',
        }),
    }, { message: 'Patient is required' })
        .optional()
        .default({
        sourceBlockName: '',
    })
        .transform(({ sourceBlockName }) => ({
        sourceBlockName,
        consumesType: FlowProducedType.Patient,
    }));
}
export function FlowConsumerOfPatientOrderSchema(props) {
    const { isRequired } = props;
    return z
        .object({
        // Don't require consumesType in the input payload, we hardcode it
        sourceBlockName: z.string().min(isRequired ? 1 : 0, {
            message: 'Source block name is required',
        }),
    }, { message: 'Order is required' })
        .optional()
        .default({
        sourceBlockName: '',
    })
        .transform(({ sourceBlockName }) => ({
        sourceBlockName,
        consumesType: FlowProducedType.PatientOrder,
    }));
}
export const FlowConsumerOfFhirPatientResponseSchema = z
    .object({
    sourceBlockName: z.string(),
})
    .transform(({ sourceBlockName }) => ({
    sourceBlockName,
    consumesType: FlowProducedType.FhirPatientResponse,
}));
export const FlowConsumerOfProviderSchema = z
    .object({
    // Don't require consumesType in the input payload, we hardcode it
    sourceBlockName: z.string(),
})
    .transform(({ sourceBlockName }) => ({
    sourceBlockName,
    consumesType: FlowProducedType.Provider,
}));
export const FlowConsumerOfLabValuesSchema = z
    .object({
    // Don't require consumesType in the input payload, we hardcode it
    sourceBlockName: z.string(),
})
    .transform(({ sourceBlockName }) => ({
    sourceBlockName,
    consumesType: FlowProducedType.LabValues,
}));
export const FlowConsumerOfDocumentExtractSchema = z
    .object({
    // Don't require consumesType in the input payload, we hardcode it
    sourceBlockName: z.string(),
})
    .transform(({ sourceBlockName }) => ({
    sourceBlockName,
    consumesType: FlowProducedType.DocumentExtract,
}));
export const FlowConsumerOfConditionsSchema = z
    .object({
    // Don't require consumesType in the input payload, we hardcode it
    sourceBlockName: z.string(),
})
    .transform(({ sourceBlockName }) => ({
    sourceBlockName,
    consumesType: FlowProducedType.Conditions,
}));
export const FlowConsumerOfMedicationsSchema = z
    .object({
    // Don't require consumesType in the input payload, we hardcode it
    sourceBlockName: z.string(),
})
    .transform(({ sourceBlockName }) => ({
    sourceBlockName,
    consumesType: FlowProducedType.Medications,
}));
export const FlowConsumerOfSurgicalHistoriesSchema = z
    .object({
    // Don't require consumesType in the input payload, we hardcode it
    sourceBlockName: z.string(),
})
    .transform(({ sourceBlockName }) => ({
    sourceBlockName,
    consumesType: FlowProducedType.SurgicalHistories,
}));
export function FlowConsumerOfVoiceCallSchema(props) {
    const { isRequired } = props;
    return z
        .object({
        // Don't require consumesType in the input payload, we hardcode it
        sourceBlockName: z.string().min(isRequired ? 1 : 0, {
            message: 'Source block name is required',
        }),
    }, { message: 'Voice call is required' })
        .optional()
        .default({
        sourceBlockName: '',
    })
        .transform(({ sourceBlockName }) => ({
        sourceBlockName,
        consumesType: FlowProducedType.VoiceCall,
    }));
}
//# sourceMappingURL=consumer.js.map